import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductSale } from '../../../interfaces/tickets/ProductSale';
import { NgPaymentService } from '../../../services/payment.service';
import creditCardType from 'credit-card-type';
import BRAND_ICONS from '../assets/icons';

@Component({
  selector: 'ng-tickets-card-confirm',
  styleUrls: ['./card-confirm.component.scss', '../../tickets/styles/ticket.scss'],
  template: `
    <section *ngIf="!error" [ngClass]="{'loading': loading}">
      <ng-core-loading *ngIf="loading"></ng-core-loading>

      <div class="confirm-card-container">
        <h2 class="card-section-title">Confirmar dados</h2>

        <div class="card-details">
          <div class="card-icon"><i class="fa fa-card"></i></div>

          <div class="card-info">
            <div class="card-info-title">Cartão de Crédito</div>
            <div class="card-info-number">**** **** **** {{ lastFourDigits(productSale?.card?.card_number) }}
              <img [src]="getCardBrandIcon()" alt="Brand icon"></div>
            <div class="card-info-name">{{ productSale.card.holder_name }}</div>
            <div class="card-info-cpf">{{ productSale.card.holder_document }}</div>
          </div>

          <div class="card-actions">
            <a class="btn btn-link" (click)="productSale.card.editing = true; nextStep.emit('add-card')">Editar</a>
          </div>
        </div>

        <div class="card-details">
          <div class="card-icon"><i class="fa fa-map-marker"></i></div>

          <div class="card-info">
            <div class="card-info-title">Endereço de Cobrança</div>

            <div class="card-info-number">
              {{ productSale?.billing_address?.line_1 }}</div>

            <div class="card-info-name">
              {{ productSale?.billing_address?.line_2 }}{{ productSale?.billing_address?.line_2 ? ' - ' : '' }}
              {{ productSale?.billing_address?.zip_code }}</div>

            <div class="card-info-cpf">
              {{ productSale?.billing_address?.city }} - {{ productSale?.billing_address?.state }}</div>
          </div>

          <div class="card-actions">
            <a class="btn btn-link" (click)="productSale.billing_address.editing = true; nextStep.emit('add-address')">Editar</a>
          </div>
        </div>

      </div>

      <div class="container-button">
        <button class="btn btn-pink" type="button" (click)="backEvent()">
          <i class="fa fa-chevron-left"></i>Voltar</button>
        <button class="btn btn-pink" type="button" (click)="create()">Adicionar cartão
          <i class="fa fa-chevron-right"></i></button>
      </div>

      <div *ngIf="!loading && error">
        <p>{{error}}</p>
        <div class="container-button">
          <button class="btn btn-pink" (click)="error = null"><i class="fa fa-chevron-left"></i> Voltar</button>
        </div>
      </div>
    </section>

    <ng-tickets-error
        *ngIf="error"
        [errorTitle]="error?.title"
        [errorMessage]="error?.message"
        [backButton]="error?.backButton"
        [validationErrors]="error?.validationErrors"
        (backButtonEvent)="error = null">
    </ng-tickets-error>
  `
})
export class CardConfirmComponent implements OnInit {

  @Output() nextStep = new EventEmitter();
  @Input() productSale: ProductSale;

  saveThisCard;

  loading = false;
  error: { title?: string, message: string, backButton?: boolean, validationErrors?: any[] };

  constructor(private paymentService: NgPaymentService) {}

  ngOnInit() {
    this.productSale.billing_address.editing = false;
    this.productSale.card.editing = false;
  }

  lastFourDigits(cardNumber: string) {
    return cardNumber.substr(cardNumber.length - 4, cardNumber.length);
  }

  getCardBrandType() {
    const brands = { 'American Express': 'Amex', 'Diners Club': 'Diners', JCB: 'Jcb' };
    const cardTypes = creditCardType(this.productSale.card.card_number);

    return cardTypes.length ? brands[cardTypes[0].niceType] || cardTypes[0].niceType : '';
  }

  getCardBrandIcon() {
    const brandsType = this.getCardBrandType();

    return BRAND_ICONS[brandsType] ? BRAND_ICONS[brandsType] : BRAND_ICONS.placeholder;
  }

  backEvent() {
    if (this.productSale.billing_address.id) {
      this.nextStep.emit('address-list');
    } else {
      this.nextStep.emit('add-address');
    }
  }

  create() {
    this.loading = true;

    if (this.productSale.saveCard) {

      if (this.productSale.billing_address.id) {

        this.createCard({
          ...this.productSale.card,
          billing_address_id: this.productSale.billing_address.id
        });
      } else {

        this.createAddressAndCard();
      }
    } else {
      this.productSale.card.last_four_digits = this.lastFourDigits(this.productSale.card.card_number);
      this.productSale.card.brand = this.getCardBrandType();
      this.productSale.card.id = 'not-addable';
      this.nextStep.emit('card-selection');
    }
  }

  createAddressAndCard() {
    const { editing, addressStreet, addressNumber, addressNeighborhood, ...data } = this.productSale.billing_address;

    this.paymentService.createAddress(data).subscribe(address => {

      this.productSale.billing_address = address;
      this.createCard({ ...this.productSale.card, billing_address_id: address.id });
    }, () => {

      this.error = {
        title: 'Ocorreu um erro :(',
        message: 'Não foi possível cadastrar o endereço. Por favor tente novamente.',
        backButton: true
      };

      this.loading = false;
    });
  }

  createCard(data) {
    this.loading = true;

    const {editing, ...card} = data;

    this.paymentService.createCard(card).subscribe(createdCard => {
      this.productSale.card = createdCard;
      this.nextStep.emit('card-selection');
    }, err => {
      this.handleError(err.error);
      this.loading = false;
    });
  }

  handleError(response) {
    switch (response.error && response.error.statusCode) {
      case 412: {
        this.error = {
          title: 'Cartão inválido :(',
          message: 'Houve um problema ao validar seu cartão. Entre em contato com a operadora do cartão ou verifique se seus dados estão' +
            ' corretos e tente novamente.',
          backButton: true
        };
        break;
      }
      case 422: {
        const validationErrors = [];
        const errors = response.error.data.response.errors || [];
        Object.keys(errors).map(key => errors[key].map(el => validationErrors.push(el)));

        this.error = {
          title: 'Dados inválidos :(',
          message: 'Verifique se seus dados estão corretos e tente novamente.',
          backButton: true,
          validationErrors
        };
        break;
      }
      default: {
        this.error = {
          title: 'Ocorreu um erro :(',
          message: 'Ocorreu um erro ao adicionar um cartão. Por favor, entre em contato com o suporte ou tente novamente.',
          backButton: true
        };
      }
    }
  }

}
